<p>studiewijzerlinkjes-detail works!</p>
<app-studiewijzerlinkjes-detail-table-row-new></app-studiewijzerlinkjes-detail-table-row-new>
